import { DefaultUrlSerializer, UrlSerializer, UrlTree } from "@angular/router";

export class LowerCaseUrlSerializer implements UrlSerializer {
  private readonly serializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    const [pathPart, queryPart] = url.split("?", 2);
    const normalizedPath = pathPart.replace(
      /(^|\/)([^\/;?#]+)/g,
      (_, prefix: string, segment: string) => `${prefix}${segment.toLowerCase()}`
    );

    return this.serializer.parse(
      queryPart !== undefined ? `${normalizedPath}?${queryPart}` : normalizedPath
    );
  }

  serialize(tree: UrlTree): string {
    return this.serializer.serialize(tree);
  }
}
